import { CommonSectionIds } from '../common.models';

export const EdgeRlSectionIds = {
    BasicInfo: CommonSectionIds.BasicInfo,
    EdgeRlInfo: 'edge-rl-info-section',
    Radar: 'edge-rl-radar-section',
    ConfigureAlarms: CommonSectionIds.ConfigureAlarms,
    DialogActions: CommonSectionIds.DialogActions,
};

export enum EdgeRlInfoFieldIds {
    Silt = 'edge-rl-info-silt',
    SiltEditButton = 'edge-rl-info-silt-edit-button',
}

export enum EdgeRlRadarFieldIds {
    PhysicalOffset = 'edge-rl-radar-physicalOffset',
    ManholeDepth = 'edge-rl-radar-manholedepth',
}

export enum EdgeRlAlarmFieldIds {
    HighLevelEnable = 'edge-rl-alarm-highLevelEnable',
    HighLevelThreshold = 'edge-rl-alarm-highLevelThreshold',
}

export const EDGE_RL_RADAR_DEVICE_TYPE = 22000;
